define([
    'text!common/component/image-slick.html',
    'WebCommon/mixin/slick',
    'css!common/component/image-slick.css'
], function(
    tpl,
    SlickMixin
){
    return {
        template: tpl,
        mixins: [SlickMixin]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/component/image-slick.js
// module id = 265
// module chunks = 0